export function ValidateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(String(email).toLowerCase()))
        return false
    return true
}

export function ValidateCPF(cpf) {

    if (cpf.length !== 11 ||
        cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999")
        return false;

    var exp = /\.|-/g
    cpf = cpf.toString().replace(exp, "");
    var digitoDigitado = Number(cpf.charAt(9) + cpf.charAt(10));
    var soma1 = 0, soma2 = 0;
    var vlr = 11;

    for (let i = 0; i < 9; i++) {
        soma1 += cpf.charAt(i) * (vlr - 1);
        soma2 += cpf.charAt(i) * vlr;
        vlr--;
    }
    soma1 = (((soma1 * 10) % 11) === 10 ? 0 : ((soma1 * 10) % 11));
    soma2 = (((soma2 + (2 * soma1)) * 10) % 11) === 10 ? 0 : (((soma2 + (2 * soma1)) * 10) % 11);

    var digitoGerado = (soma1 * 10) + soma2;
    if (digitoGerado !== digitoDigitado)
        return false
    return true
}

export function ValidateCNPJ(cnpj) {
    if (!cnpj) return false;
    cnpj = cnpj.toString().replace(/[.\-\/]/g, '').toUpperCase();
    if (cnpj.length !== 14) return false;
    return /^[A-Z0-9]{14}$/.test(cnpj);
}

export function ValidateData(data) {
    var exp = /\d{2}\/\d{2}\/\d{4}/
    if (!exp.test(data))
        return false
    return true
}

export function isEmptyObject(obj) {
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop))
            return false;
    }
    return true;
}